<template>
  <div class="page" v-wechat-title="$route.meta.title='我的已购'">
    <!--顶部描述-->
    <p class="title border-box">已购解说专辑，共{{total}}张</p>
    <!--已购买列表-->
    <div class="list border-box" >
      <template v-for="(item,index) in root">
        <div class="list-box box border-box" :class="item.vipid?'vip':''"  @click="(item.vipid||item.shopname=='网传')?'':goVideoPlay(item.bid,item.shopid,item.bagtype,item.turnOn,item.spotId)">
          <div class="block list-img">
            <img src="../../assets/pay-member.png" alt="" v-if="item.vipid">
            <img class="img bor50" :src="item.headimg?item.headimg:require('../../assets/h5_logo.png')" alt="" v-else-if="item.bagtype==5">
            <img class="img bor50" :src="item.guideheadimg2?item.guideheadimg2:(item.guideheadimg?item.guideheadimg:require('../../assets/h5_logo.png'))" alt="" v-else>
          </div>
          <div class="block flex list-info" :class="!item.htype?'end':''" v-if="item.vipid">
            <p class="list-group hide">平台会员{{!item.htype?' （已到期）':''}}</p>
            <p class="list-name hide">{{item.title}}</p>
            <p class="list-editor hide">到期时间：{{item.gdate}}</p>
          </div>
          <div class="block flex list-info" v-else>
            <p class="list-group hide">{{item.shopname =='网传'?'会员激活':item.shopname}}</p>
            <p class="list-name hide">{{item.bagname}}</p>
            <p class="list-editor hide">{{item.guidename2?item.guidename2:item.guidename}}{{item.description?('/'+item.description):''}}</p>
            <p class="list-editor hide">{{item.paytime}}  <font v-if="item.outtime">（到期时间：{{item.outtime}}）</font></p>
            <img class="list-icon" src="../../assets/icon_36.png" alt="" v-if="item.isBlock==0">
          </div>
        </div>
      </template>

      <p class="load-tip" ref="loadtip">{{loadText}}</p>
    </div>
  </div>
</template>
<script>
  import { mapState, mapMutations } from 'vuex'
  import { getPurchase } from "@/service/getData";
  import { loadMore } from "@/config/mUtils";
  import {setStore, getStore, removeStore} from '@/config/mUtils'

  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return{
        userInfo: {},
        total:'',
        root: [],
        page: 1,
        rows: 10,
        loadText: "数据加载中",

        TimeStamp: new Date().getTime(),  //获取当前时间
        appKey: '',
        appKeyA: '',
      }
    },
    computed: {

    },
    created() {
      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey
      if (this.appKey) {
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey": this.appKey});
      } else {
        setStore("appKey", {"appKey": ""});
      }

      let self = this;
      this.$loading.show('数据加载中');
      self.initData(self.page);

      window.addEventListener("scroll",this.handleFun);
    },
    beforeDestroy(){
      window.removeEventListener("scroll",this.handleFun)
    },
    methods: {

      async initData(page) {
        this.userInfo = getStore("userInfo");
        let res = await getPurchase({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          page: page,
          rows: this.rows
        });

        if (res.errcode === '00000'){
          this.$loading.hide();
          this.total = res.data.total
          let root = res.data.root
          if (page >= Math.ceil(this.total / this.rows)) {
            this.loadText = '已经到底了'
          } else {
            this.loadText = '加载更多'
          }
          if (root.length > 0) {
            this.root = [...this.root, ...root];
          } else {
            if (page == 1) {
              this.root = [];
              this.loadText = '暂无数据'
            } else {
              this.loadText = '已经到底了'
            }
          }

        }
      },

      handleFun: function (){
        let self = this;
        self.$nextTick(function() {
          loadMore(self,function(page){
            self.initData(page);
          });
        })

      },

      //跳转到专辑详情页
      goVideoPlay(pid,shopid,bagtype,turnOn,spotId){
        if(turnOn==2){
          this.$router.push({
            path: `/video-play-py?${'id='+pid+'&spotid='+spotId+'&shopid='+shopid+'&appKey='+this.appKey}`
          });
        }else {
          if(bagtype == 1){
            this.$router.push({
              path: `/video-play1?${'id='+pid+'&shopid='+shopid+'&bagtype=1'+'&appKey='+this.appKey}`
            });
          }else if(bagtype == 2){
            this.$router.push({
              path: `/video-vr?${'id='+pid+'&shopid='+shopid+'&bagtype=2'+'&appKey='+this.appKey}`
            });
          }else if(bagtype == 4){
            this.$router.push({
              path: `/video-list?${'id='+pid+'&shopid='+shopid+'&bagtype=4'+'&appKey='+this.appKey}`
            });
          }else if(bagtype == 5){
            this.$router.push({
              path: `/view-detail-group?${'id='+pid+'&shopid='+shopid+'&bagtype=5'+'&appKey='+this.appKey}`
            });
          }else if(bagtype == 'lz'){
            this.$router.push({
              path: `/video-play-lz?${'id='+pid+'&shopid='+shopid+'&bagtype=lz'+'&appKey='+this.appKey}`
            });
          }else {
            this.$router.push({
              path: `/video-play?${'id='+pid+'&shopid='+shopid+'&appKey='+this.appKey}`
            });
          }
        }

      },

    },
    components: {

    }

  }

</script>

<style scoped>

  .title{width:100%;height:.72rem;line-height:.72rem;padding:0 .25rem;font-size:.24rem;color:#999;background:#f9f9f9;}
  .list{padding:0 .25rem;background:#fff;}
  .list-box{width:100%;height:1.69rem;padding:.18rem .20rem;margin-top:.14rem;border:1px solid #eee;-webkit-border-radius:.13rem;border-radius:.13rem;}
  .list-img{float:left;position:relative;width:1.45rem;border-right:1px solid #eee;}
  .list-img img{width:1.27rem;height:1.28rem;}
  .list-info{ position: relative; padding-left:.20rem;}
  .list-group{font-size:.20rem;color:#fa9900;}
  .list-name{margin-top:.05rem;font-size:.3rem;color:#6f7f84;}
  .list-editor{margin-top:.05rem;font-size:.20rem;color:#bbc4b8;}
  .list-icon{ position: absolute; top: 0; right: 0; z-index: 1; width: 1.17rem; height: 1.17rem; }

  .list-box.vip{ height: 1.4rem; background-color: #f9f9f9; }
  .list-box.vip .list-img img{ width: .9rem; height: .9rem; margin: .08rem 0 0 .15rem; }
  .list-box.vip .list-group{ color: #ff5511 }
  .list-info.end .list-group,.list-info.end .list-name,.list-info.end .list-editor{ color: #bbc4b8; }

</style>



// WEBPACK FOOTER //
// src/page/purchase/purchase.vue